<template>
    <div class="Admin">
        <div class="row">
            <div class="col">
                <ActionButton class="DeleteButton"
                              :requires-confirmation="true"
                              confirmation-string="WARNING: You are about to delete this church's entire record.  This should only be done if it was added by mistake.  If this church is no longer active with Olive Crest, you should change it's status instead of deleting it."
                              endpoint="StrongFamilies/Churches"
                              method="DELETE"
                              :payload="{Id: RecordData.Id}"
                              :perform-global-update="true"
                              button-variant="danger"
                              button-string="DELETE CHURCH RECORD"
                              button-size="md"
                              v-on:success="OnDeleted"
                              style="white-space: normal;"/>
            </div>
        </div>
        <!--<div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>-->
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    //import components
    import ActionButton from '../../../../Core/ItemEditors/ActionButton.vue';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            OnDeleted() {
                this.$parent.CloseRecord();
            }
        },
        components: {
            ActionButton
        },
        mounted() {

        },
        computed: {
            
        }
    }
</script>

<style scoped>
    .DeleteButton {
    display: inline-block;
    font-size:4px;
    }
</style>